/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Steps_Col_StepInputs */

const en_dr_steps_col_step = /** @type {(inputs: Dr_Steps_Col_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step`)
};

const id_dr_steps_col_step = /** @type {(inputs: Dr_Steps_Col_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah`)
};

/**
* | output |
* | --- |
* | "Step" |
*
* @param {Dr_Steps_Col_StepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_steps_col_step = /** @type {((inputs?: Dr_Steps_Col_StepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Steps_Col_StepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_steps_col_step(inputs)
	return en_dr_steps_col_step(inputs)
});